import { FormikErrors } from 'formik';
import { NewDeclarationFormValues } from 'pages/SubmissionFormWizard/SubmissionFormWizard';

const hasErrors = (errors: FormikErrors<NewDeclarationFormValues>): boolean => {
    if (!errors) return false;
    return Object.values(errors).some(
        (error) => error && (typeof error === 'string' || hasErrors(error))
    );
};

export default hasErrors;
